const WIDTH_SP = 769;
const body = document.querySelector("body");
// スクロール位置を保存する変数
let lastScrollY = 0;


/* html読み込み直後の共通処理
-------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function(){
  const header = document.getElementById("header");

  // ページの表示
  body.style.opacity = "1";
  body.classList.remove("preload");

  // retina対応
  console.log("retina set");
  const retinaCheck = window.devicePixelRatio;
  let retinaimg = "";
  if (retinaCheck >= 2) {
    let target = document.getElementsByClassName('retina');
    for (let i = 0; i < target.length; i++) {
      if (target[i].getAttribute('src')) {
        retinaimg = target[i].getAttribute('src').replace(/\.(?=(?:png|jpg|jpeg).*$)/i, '--2x.');
      } else if (target[i].dataset.src) { // lazyload用
        retinaimg = target[i].dataset.src.replace(/\.(?=(?:png|jpg|jpeg).*$)/i, '--2x.');
      }
      target[i].setAttribute('srcset', retinaimg + ' 2x');
    }
  }

  /* FAQ開閉 ------- */
  const moreBtn = Array.from(document.querySelectorAll('.faq__item--q'));

  moreBtn.forEach((item) => {
    item.addEventListener('click', function () {
      this.classList.toggle('is-on');
      const target = this.nextElementSibling;

      if (target.style.maxHeight) {
        target.style.maxHeight = null;
      } else {
        target.style.maxHeight = target.scrollHeight + 'px';
      }
    });
  });

  /* スライダー ------- */
  // product
  //サムネイル
  const prodThumbnail = new Swiper('.prod-thumbnail', {
    slidesPerView: 5.03,
    spaceBetween: "0.5%",
    freeMode: true,
    allowTouchMove: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });

  //スライダー
  /* 製品紹介 ------- */
  const prodSwiper = new Swiper('.prod-slider', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: prodThumbnail
    }
  });
  /* voice1 ------- */
  let voice1Swiper = new Swiper('.voice1__slide', {
    slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween: 8,
    centeredSlides: false,
    grabCursor: true,
    loop: false,
    autoplay: { delay: 10000 },
    // レスポンシブ
    breakpoints: {
      768: {
        slidesPerView: 1.1,
      }
    }
  });
  /* voice2 ------- */
  let voice2Swiper = new Swiper('.voice2__slide', {
    slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween: 8,
    centeredSlides: false,
    grabCursor: true,
    autoplay: { delay: 10000 },
    loop: true,
    // レスポンシブ
    breakpoints: {
      /* 768: {
        slidesPerView: 1.1,
      } */
    }
  });

  // モーダルを閉じる
  let closeBtns = document.querySelectorAll(".modalContent__close, .overlay");
  for(let i = 0; i < closeBtns.length; i++){
    closeBtns[i].addEventListener("click",() => {
      let body = document.getElementsByTagName('body')[0];
      body.style.overflow = "";

      let modalBodyElem = document.getElementById('voice-modal');
      modalBodyElem.classList.remove("active");

      let voiceContent = document.getElementsByClassName('voice__content');
      for(let l = 0; l < voiceContent.length; l++) {
        voiceContent[l].classList.remove("active");
      }

    }, false);
  }

});

// スクロールイベント
window.addEventListener('scroll', function() {
  const mvEndPos = document.getElementById("mv").clientHeight;
  if(isScrolledUp(lastScrollY)) {
    header.classList.add("visible");
  } else {
    header.classList.remove("visible");
  }

  if((window.pageYOffset || document.documentElement.scrollTop) > mvEndPos) {
    header.classList.add("bg");
  } else {
    header.classList.remove("bg");
  }
  lastScrollY = window.scrollY; // スクロール位置を更新

  // 追従バナー
  const footerBaner = document.getElementById("fixed-cta");
  const ctaDispPosition = 
    document.getElementById("voice1").getBoundingClientRect().top - window.innerHeight;
  if(ctaDispPosition < 0) {
    footerBaner.classList.add("show");
  } else {
    footerBaner.classList.remove("show");
  }
});

// スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var adjust = 0;
    var speed = 500; // ミリ秒
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});

/* 要素のフェード
-------------------------------------------------- */
window.addEventListener("load", doFade);
window.addEventListener("scroll", doFade);
function doFade() {
  let fadeInTarget = document.querySelectorAll(".js-fade-in");
  for (let i = 0; i < fadeInTarget.length; i++) {
    var elem = fadeInTarget[i];
    var rect = elem.getBoundingClientRect().top;
    var scroll = window.pageYOffset || document.documentElement.scrollTop;
    var offset = rect + scroll;
    var windowHeight = window.innerHeight; // 現在のブラウザの高さ
    // 実行時のディレイ
    var delay = elem.dataset.delay == undefined ? 0 : elem.dataset.delay;
    // 位置に関係なくload時に実行するかどうか
    var isLoad = elem.dataset.load == undefined ? false : elem.dataset.load;
    // 実行する位置
    var positionPc = elem.dataset.positionPc == undefined ? 200 : elem.dataset.positionPc;
    var positionSp = elem.dataset.positionSp == undefined ? 0 : elem.dataset.positionSp;
    var position = document.body.clientWidth > 751 ? positionPc : positionSp;
    var dispPosition = offset - windowHeight + position; // 実行位置
    // 速度
    var duration = elem.dataset.duration == undefined ? 1.5 : elem.dataset.duration;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add("js-scroll-in");
      elem.style.transitionDelay = delay + "s";
      elem.style.transitionDuration = duration + "s";
    }
  }
}

/* scrollでis-onクラスを付与する
-------------------------------------------------- */
window.addEventListener("load", setIsOn);
window.addEventListener("scroll", setIsOn);
function setIsOn() {
  let fadeInTarget = document.querySelectorAll(".js-scroll");
  for (let i = 0; i < fadeInTarget.length; i++) {
    const elem = fadeInTarget[i];
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight; // 現在のブラウザの高さ

    // 位置に関係なくload時に実行するかどうか
    const isLoad = elem.dataset.load == undefined ? false : elem.dataset.load;
    // 実行する位置
    const dispPosition = offset - windowHeight; // 実行位置

    if (scroll > dispPosition || isLoad) {
      elem.classList.add("is-on");
    }
  }
}

/**
 * 上スクロールされたかどうか
 * @returns boolean true:上スクロール
 */
function isScrolledUp(lastScrollY) {
  return window.scrollY < lastScrollY;
}

/* モーダルを開く
-------------------------------------------------- */
function setVoiceModal(modalId){
  let body = document.getElementsByTagName('body')[0];
  const modalBodyElem = document.getElementById('voice-modal');
  let modal = document.getElementById(modalId);
  body.style.overflow = "hidden";
  modalBodyElem.classList.add("active");
  modal.classList.add("active");
  return true;
}
